const $inject = [];

const hotelProviderBrandFilter = () => {
  return (room) => {
    if (room.Rates[0].RateSourceName === 'BookingDotCom') return 'BKG';
    if (room.Rates[0].RateSourceCode === '110') return 'EXP';
    if (room.Rates[0].IsUnlimitedAllotment) return 'REQ';
    
    const brand = room.Provider.Brand;
    const brandParents = {
      CON: 'CTM'
    };

    return brandParents[brand] || brand;
  }
};

hotelProviderBrandFilter.$inject = $inject;

export default hotelProviderBrandFilter;



// WEBPACK FOOTER //
// ./src/filters/hotelProviderBrandFilter.js